(function () {
  if (window.__zcServiceInit) return;
  window.__zcServiceInit = true;

  function setOpen(btn, body, open) {
    var inner = body.querySelector(".zcs-accordion-body-inner");
    btn.classList.toggle("open", open);
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    body.classList.toggle("open", open);

    if (open) {
      // Pixel row height — 1fr collapses when the child uses overflow:hidden
      // inside an indefinite grid. Measure, then animate the grid row.
      body.style.gridTemplateRows = "0fr";
      // Force a reflow so the browser starts from 0 before expanding
      void body.offsetHeight;
      var h = inner ? inner.scrollHeight : 0;
      body.style.gridTemplateRows = h + "px";
    } else {
      body.style.gridTemplateRows = "0fr";
    }
  }

  function closeAll(exceptBody) {
    document.querySelectorAll(".zcs-accordion-btn").forEach(function (btn) {
      var body = btn.nextElementSibling;
      if (!body || !body.classList.contains("zcs-accordion-body")) return;
      if (exceptBody && body === exceptBody) return;
      setOpen(btn, body, false);
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".zcs-accordion-btn");
    if (!btn) return;

    var body = btn.nextElementSibling;
    if (!body || !body.classList.contains("zcs-accordion-body")) return;

    var willOpen = !body.classList.contains("open");
    closeAll(willOpen ? body : null);
    setOpen(btn, body, willOpen);
  });

  window.addEventListener("resize", function () {
    document.querySelectorAll(".zcs-accordion-body.open").forEach(function (body) {
      var inner = body.querySelector(".zcs-accordion-body-inner");
      if (!inner) return;
      body.style.gridTemplateRows = inner.scrollHeight + "px";
    });
  });

  function initShopMarquee(root) {
    if (!root || root.dataset.zcShopMarqueeInit === "true") return;
    root.dataset.zcShopMarqueeInit = "true";

    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      root.classList.add("is-static");
      return;
    }

    root.classList.add("is-moving");

    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          root.classList.toggle("is-offscreen", !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    io.observe(root);
  }

  function initShopMarquees(scope) {
    (scope || document).querySelectorAll("[data-zc-shop-marquee]").forEach(initShopMarquee);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initShopMarquees(document);
    });
  } else {
    initShopMarquees(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initShopMarquees(event.target);
  });
})();
